import { useEffect, useState } from "react";
import { Plus, Trash2, User } from "lucide-react";
import { toast } from "sonner";
import adminApi, { apiError } from "@/services/adminApi";

const inputCls = "px-3 py-2 bg-zinc-800/80 border border-zinc-700/40 rounded-lg text-sm text-white placeholder-zinc-500 focus:outline-none focus:border-amber-500/50";

export default function AdminsPage() {
  const [admins, setAdmins] = useState([]);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const load = () => adminApi.listAdmins().then(({ data }) => setAdmins(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const handleAdd = async () => {
    try {
      await adminApi.createAdmin({ username, password });
      toast.success("Admin əlavə olundu");
      setUsername("");
      setPassword("");
      load();
    } catch (err) {
      toast.error(apiError(err));
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Admin silinsin?")) return;
    try {
      await adminApi.deleteAdmin(id);
      toast.success("Silindi");
      load();
    } catch (err) {
      toast.error(apiError(err));
    }
  };

  return (
    <div data-testid="admin-admins-page">
      <h1 className="text-2xl font-bold mb-6">Adminlər</h1>

      <div className="flex flex-col md:flex-row gap-2 mb-6">
        <input data-testid="admin-new-username" placeholder="İstifadəçi adı" value={username} onChange={(e) => setUsername(e.target.value)} className={`${inputCls} md:w-56`} />
        <input data-testid="admin-new-password" type="password" placeholder="Şifrə (min 4)" value={password} onChange={(e) => setPassword(e.target.value)} className={`${inputCls} md:w-56`} />
        <button data-testid="admin-create-btn" onClick={handleAdd} disabled={!username || password.length < 4} className="flex items-center gap-2 px-4 py-2 bg-amber-500 hover:bg-amber-400 disabled:opacity-50 text-black font-semibold rounded-lg text-sm transition-colors">
          <Plus className="w-4 h-4" /> Əlavə et
        </button>
      </div>

      <div className="space-y-2 max-w-xl">
        {admins.map((a) => (
          <div key={a.id} data-testid={`admin-row-${a.username}`} className="flex items-center gap-4 bg-zinc-900/60 border border-zinc-800 rounded-xl px-4 py-3">
            <div className="w-9 h-9 rounded-full bg-amber-500/10 flex items-center justify-center flex-shrink-0">
              <User className="w-4 h-4 text-amber-500" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-sm">{a.username}</p>
              {a.created_at && <p className="text-[10px] text-zinc-500">{new Date(a.created_at).toLocaleDateString("az-AZ")}</p>}
            </div>
            <button data-testid={`admin-delete-${a.username}`} onClick={() => handleDelete(a.id)} className="p-2 text-zinc-400 hover:text-red-400 transition-colors">
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
